import { DialogContent } from "@material-ui/core";
import { CancelFoiDialog } from "./CancelFoiDialog";
import { CloseFoiDialog } from "./CloseFoiDialog";
import { CloseDialogActionTypes } from "./CloseSelectorDialog";

export const CloseDialogDecider: React.FC<{
  item: any;
  actionDialog: CloseDialogActionTypes;
  onClose: () => void;
}> = ({ item, actionDialog, onClose }) => {
  switch (actionDialog.action) {
    case "Close":
      return <CloseFoiDialog foiItem={item} onClose={onClose} />;
    case "Cancel":
      return <CancelFoiDialog foiItem={item} onClose={onClose} />;
    default:
      return <DialogContent>Create Dialog action not supported</DialogContent>;
  }
};
